const getAuthHeaders = () => {
  const sessionToken = localStorage.getItem('sessionToken');
  return {
    'Authorization': `Bearer ${sessionToken}`,
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  };
};

const handleResponse = async (response) => {
  if (!response.ok) {
    // 401 = not authenticated (missing/expired/invalid token). THIS is the
    // only status that means the session is gone, so it's the only one that
    // clears the token and bounces to login.
    if (response.status === 401) {
      localStorage.removeItem('sessionToken');
      window.location.href = '/login';
      throw new Error('Session expired. Please login again.');
    }
    // 403 = authenticated but not permitted for THIS resource (e.g. an
    // owner-only backend path). It must NOT log the admin out — surface it as
    // a normal error so the calling view can show a message. (Previously every
    // 403 wiped the session and redirected to login, which is why viewing
    // another user's pledge kicked the admin out.)
    const errorData = await response.json().catch(() => null);
    throw new Error(errorData?.error || errorData?.message || `HTTP error! status: ${response.status}`);
  }
  
  // Handle 204 No Content responses that have no body
  if (response.status === 204 || response.headers.get('content-length') === '0') {
    return {};
  }
  
  return response.json();
};

const fetchWithAuth = async (url, options = {}) => {
  const defaultOptions = {
    headers: getAuthHeaders(),
    mode: 'cors'
  };

  // Merge the default options with any provided options
  const mergedOptions = {
    ...defaultOptions,
    ...options,
    headers: {
      ...defaultOptions.headers,
      ...(options.headers || {})
    }
  };

  try {
    const response = await fetch(url, mergedOptions);
    return handleResponse(response);
  } catch (error) {
    if (error.message.includes('CORS')) {
      throw new Error('Network error: API is not accessible. Please check your connection or contact support.');
    }
    throw error;
  }
};

export const authenticatedGet = (url) => fetchWithAuth(url);

export const authenticatedPost = (url, data) => 
  fetchWithAuth(url, {
    method: 'POST',
    body: JSON.stringify(data)
  });

export const authenticatedPut = (url, data) =>
  fetchWithAuth(url, {
    method: 'PUT',
    body: JSON.stringify(data)
  });

export const authenticatedDelete = (url, data) =>
  fetchWithAuth(url, {
    method: 'DELETE',
    body: data ? JSON.stringify(data) : undefined
  });